<template>
  <div class="container">
      <div class="topView">
           <img class="topimg" src="../../assets/images/img_space_card.jpg"/>
            <!-- <img :src="QRCode" class="qrCode_icon"/> -->
            <div  class="qrCode_icon" ref="qrCodeUrl"></div>
            <img v-if="visitorOutput.status !=2 ||isOut" class="qrCode_effect" src="../../assets/images/icon_fk_take_effect.png">
            <div class="m1_text2">预约编号：{{visitorOutput.reserveNo}}</div>
      </div>
      <div class="bottomView">
           <div class="bottom_item1">
               <div class="bottom_item_line"></div>
               <span class="bottom_item_title">拜访信息</span>
           </div>

           <!-- <div class="bottom_item">
               <span class="bottom_item_leftText">业主</span>
               <span class="bottom_item_rightText" v-if="visitorOutput.cityName">{{visitorOutput.cityName}}</span>
           </div> -->
            <div class="bottom_item">
               <span class="bottom_item_leftText">项目</span>
               <span class="bottom_item_rightText">{{visitorOutput.marketName}}</span>
           </div>
            <div class="bottom_item">
               <span class="bottom_item_leftText">访客姓名</span>
               <span class="bottom_item_rightText">{{visitorOutput.visitorUserName}}</span>
           </div>
            <div class="bottom_item">
               <span class="bottom_item_leftText">电话号码</span>
               <span class="bottom_item_rightText">{{visitorOutput.visitorMobile}}</span>
           </div>
            <div class="bottom_item">
               <span class="bottom_item_leftText">拜访日期</span>
               <span class="bottom_item_rightText">{{visitorOutput.visitorDate}}</span>
           </div>
           <div class="bottom_item">
               <span class="bottom_item_leftText">拜访公司</span>
               <span class="bottom_item_rightText">{{visitorOutput.visitorCompany}}</span>
           </div>
           <div class="bottom_item">
               <span class="bottom_item_leftText">拜访地址</span>
               <span class="bottom_item_rightText" v-if="visitorOutput.visitorFloor">{{visitorOutput.visitorFloor}}</span>
           </div>
           <div class="bottom_item" v-for="item in tbVisitorRegs_filter" :key="item.regKey">
                <span class="bottom_item_leftText label_flex">{{item.regDicName}}</span>
                <span class="bottom_item_rightText">{{item.regDicValue}}</span>
            </div>
      </div>
  </div>
</template>

<script>
import{getVisitorDetailById,desEncrypt,transformToBase64}from "../../utils/api";
import QRCode from 'qrcodejs2'
import util from '../../utils/util';
import { mapState } from "vuex";
export default {
  name: "visitAccessCard",
  data() {
    return {
      visitorOutput:'',
      tbVisitorRegs:[],
      timestamp:'',
      QRCode:'',
      ID:'',
      isToday:false,
      isOut:false,
      qrcodeTool:'',
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    }),
    tbVisitorRegs_filter(){
        return this.tbVisitorRegs.filter(item=>{
            return item.regKey == 'visitor_is_fever' || item.regKey == 'visitor_is_mask' || item.regKey == 'visitor_arrive_wh'
        })
    }
  },
  created() {
    //this.getNoticeListAction();
  },
  activated () {
    if (this.ID !== this.$route.params.id) {
      this.ID =  this.$route.params.id;
      //this.getNoticeDetailAction();
      console.log(this.ID);
      this.visitAccessCardInfo();
    }
  },
   methods: {
        visitAccessCardInfo(){
            let params = {
                visitorId : this.ID,
            }
            getVisitorDetailById(params).then(res => {
                console.log(res);
                if (res.res.code === 10000 && res.body) {
                    this.visitorOutput =res.body.visitorOutput;
                    this.tbVisitorRegs = res.body.tbVisitorRegs;
                     let date = new Date();
                     var year = date.getFullYear()
                     var month = date.getMonth() + 1;
                     var day = date.getDate();
                    console.log(date)
                    //  tdStr ="2019-12-12"
                     var vdSrr = this.visitorOutput.visitorDate
                     var str1 = vdSrr.substring(0,10)
                     console.log(str1);
                     var arr = str1.split('-')
                    //  var vdate = new Date(vdSrr);
                    //  console.log(vdate);
                     var vyear = parseInt(arr[0])
                     //vdate.getFullYear()
                     var vmonth = parseInt(arr[1])
                     //vdate.getMonth() + 1;
                     var vday = parseInt(arr[2])
                     //vdate.getDate();
                    //  var str =year+"-"+ month + "-" +day +"       :        " + vyear+"-"+ vmonth + "-" +vday
                    //  util.showModal("",str,true,"比较的日期",() => {

                    //  });
                   // console.log()
                     if(year<=vyear){
                         console.log(' in year')
                         this.isOut=false;
                         if(year==vyear){  //年相同才比较月
                            if(month<=vmonth){
                                console.log(' in month')
                                 this.isOut=false;
                                if(month == vmonth){ //月相同才比较日期
                                    if(day<=vday){
                                        console.log(' in day')
                                        this.isOut =false;
                                    }else{
                                        this.isOut=true;
                                    }
                                }
                            }else{
                                this.isOut=true;
                            }
                         }
                     }else{ //当前年大于预约年 过期
                         this.isOut=true;
                     }
                     console.log(' this.isOut  ===  ' + this.isOut)
                     var tdStr =year+"-"+month+"-"+day;

                     if(vdSrr.indexOf(tdStr )>-1){
                         this.isToday =true;
                     }else{
                         this.isToday =false;
                     }

                    this.timestamp =res.res.timestamp
                    //this.getQRCode();
                    this.getTenantQrCode();
                }
            });


        },

          //获取二维码数据
      getTenantQrCode() {
         //  var qobj = JSON.parse(this.visitorOutput.qrcode)
            let content = {
                uid: this.visitorOutput.id,
                marketId: this.visitorOutput.marketId,
                operationType: "2",
                userId: this.visitorOutput.userId,
                timestamp:this.timestamp.toString()
            }
             desEncrypt(content).then(res => {
                console.log("获取门禁数据："+JSON.stringify(res))
                //   this.pageShow = true;
                //   this.hasData = true;
                // let content_m = {
                //       uid: res.uid,
                //       operationType: res.operationType,
                //       userId: res.userId,
                //       marketId:res.marketId,
                //       timestamp: res.timestamp,
                //       // actId: res.actId,
                //       // orderNo: res.orderNo,
                //       // orderType: res.orderType
                //     };
                this.creatQrCode(res);
            })
            //访客不加密
           // this.creatQrCode(content);
      },

      //js生成二维码
      creatQrCode(dic) {
        //{qrcode:code}  ;
        if(!this.qrcodeTool){
           var wh =document.body.clientWidth;
           var w =160*wh/375;
           var h =160*wh/375;
           var qDarkcolor = '#000000';
           if(this.visitorOutput.status !=2 ||this.isOut){
                qDarkcolor ='#E6E6E6'
           }

           this. qrcodeTool = new QRCode(this.$refs.qrCodeUrl, {
                    text: dic,
                    //JSON.stringify(map).replace(/(\")/g,"\\$1"),
                    width: w,
                    height: h,
                    colorDark: qDarkcolor,
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.M
            })
        }else{
            this.qrcodeTool.clear(); // 清除代码
            this.qrcodeTool.makeCode(dic); // 生成另外一个二维码
        }
      },

        getQRCode() {
            let content = {
                qrcode: this.visitorOutput.qrcode
            }
            transformToBase64(content).then(res => {
                if (res.res.code === 10000) {
                    console.log("res二维码")
                    console.log(res)
                    this.QRCode = res.body.encodeBase64
                }
           });
        },
   }


};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #EEEEEE;
}
.topView{
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    width:94.7%;
    // height:704px;
    background:rgba(255,255,255,1);
    border-radius:16px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-items: center;
    align-content: center;
    position: relative;
}

.topimg{
    width: 100%;
    height:100px ;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

}

.qrCode_icon{
    margin-top: 100px;
    width: 320px;
    height: 320px;
}
.qrCode_effect{
    position: absolute;
    top: 132px;
    right: 32px;
    width: 120px;
    height: 120px;
}
.m1_text2{
    height:36px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:36px;
    margin-top: 48px;
    margin-bottom: 100px;
}

.bottomView{
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    width:94.7%;
    // height:704px;
    background:rgba(255,255,255,1);
    border-radius:16px;
    padding-bottom: 100px;
    margin-bottom: 20px;
    flex-direction: column;
    display: flex;
}

.bottom_item{
    margin-left: 40px;
    margin-top: 20px;
    width: 100%;
    flex-direction: row;
    display: flex;
}
.bottom_item1{
    margin-left: 40px;
    margin-top: 40px;
    width: 100%;
    flex-direction: row;
    display: flex;
}
.bottom_item_line{
    width:6px;
    margin-top: 10px;
    height:24px;
    background:rgba(23,64,218,1);
    display: flex;
}
.bottom_item_title{
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:44px;
    margin-left: 12px;
}
.bottom_item_leftText{
    width:140px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:36px;
    display: flex;
}
.label_flex{
    width:380px;
}
.bottom_item_rightText{
    width: 510px;
    font-size:26px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:36px;
}

</style>